import React from "react";
import heroAbout from "../../assets/image/hero-about-2.png";
import Hero from "../../components/Hero/Hero";
import ReviewsPage from "../../components/ReviewsPage/ReviewsPage";
import  ScrollToTopOnMount  from '../../utils/ScrollToTop'

const About = () => {
  
  return (
    <section>
      <ScrollToTopOnMount />
      <Hero img={heroAbout}>
        <div className="hero">
          <div className="hero-text">
            <div className="hero-title">
              <h3>In a unique combination of creativity and passion, The Mixologist's Playground is born, <br/> a modern oasis where the art of cocktails blends with the relaxed atmosphere of an urban playground.</h3>
            </div>

          </div>
        </div>
      </Hero>
      <div className="container-sm mb-5" id="allReviews">
        <h2 className="mt-5">Venue reviews</h2>
        <ReviewsPage />
      </div>
    </section>
  );
};

export default About;
